module.exports = __webpack_public_path__ + "img/yesmovies-alternatives.e711806d.webp";